import React, { useContext } from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { withPrefix } from 'gatsby';
import { Container } from '@legacy-vfuk/core-container';
import { Heading } from '@legacy-vfuk/core-heading';
import { Paragraph } from '@legacy-vfuk/core-paragraph';
import LinkWithIcon from '@legacy-vfuk/core-link-with-icon';
import { SectionRedCampaignBannerProps } from './types/SectionRedCampaignBanner.types';
import {
  ContainerWrapper,
  ContentWrapper,
  ImageWrapper,
  BetaLabel,
} from './styles/SectionRedCampaignBanner.styles';
import { DirectionContext } from '../../../../contexts/DirectionContext';
import fireButtonAndLinkClicksEvent from '../../../../helpers/fireButtonAndLinkClicksEvent';
import { addHashIfMissing } from '../../../../helpers/navigationHelpers';
import CtaButtonRow from '../../Elements/CtaButtons/CtaButtonRow';

const SectionRedCampaignBanner = ({
  title,
  bodyText,
  linkText,
  bannerColor = 'red',
  targetUrl,
  linkType,
  scrollToId,
  backgroundColor,
  image,
  label,
  buttonRow,
}: SectionRedCampaignBannerProps) => {
  const direction = useContext(DirectionContext);
  const imageAlt = image.imageTitle.description || image.imageTitle.title;
  const bannerAppearance = bannerColor === 'red' ? 'alt2' : 'alt1';

  const onClickBanner = () => {
    if (buttonRow) {
      return;
    }

    fireButtonAndLinkClicksEvent({
      event_label: linkText || title,
      event_action: 'link click',
    });
  };

  const getContainerHref = (): string | undefined => {
    if (buttonRow) {
      return;
    }

    return linkType === 'scroll'
      ? addHashIfMissing(scrollToId || '')
      : withPrefix(targetUrl);
  };

  const getLinkWithIconHref = (): string => {
    return linkType === 'scroll'
      ? addHashIfMissing(scrollToId || '')
      : withPrefix(targetUrl);
  };

  return (
    <ContainerWrapper
      backgroundColor={backgroundColor}
      bannerColor={bannerColor}
    >
      <Container
        href={getContainerHref()}
        appearance={bannerAppearance}
        onClick={buttonRow ? undefined : onClickBanner}
      >
        <ContentWrapper isRtl={direction === 'rtl'}>
          {label && (
            <BetaLabel>
              <span>{label}</span>
            </BetaLabel>
          )}
          <Heading size={2} text={title} inverse />
          <Paragraph inverse appearance="primary">
            {bodyText}
          </Paragraph>
          {linkText && (
            <LinkWithIcon
              appearance="secondary"
              inverse
              href={getLinkWithIconHref()}
              text={linkText}
              icon={{
                name: 'chevron-right',
                justify: 'right',
              }}
            />
          )}
          <CtaButtonRow {...buttonRow} spacing={5} />
        </ContentWrapper>
        <ImageWrapper>
          <GatsbyImage
            image={getImage(image.imageTitle) as IGatsbyImageData}
            alt={imageAlt}
          />
        </ImageWrapper>
      </Container>
    </ContainerWrapper>
  );
  // }
};

export default SectionRedCampaignBanner;
